var expiryInMilliSeconds = 24 * 60 * 60 * 1000;
export var TEN_YEARS_EXPIRY = 365 * 10;
var CookieManager = {
  createCookie: function createCookie(name, value) {
    var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TEN_YEARS_EXPIRY;
    var secure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sessionCookie = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var expiryDate = arguments.length > 5 ? arguments[5] : undefined;
    if (typeof document !== 'undefined') {
      var expires = '';
      var https = '';
      if (sessionCookie) {
        expires = '';
      } else if (expiryDate) {
        expires = '; expires='.concat(expiryDate.toUTCString());
      } else if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * expiryInMilliSeconds);
        expires = '; expires='.concat(date.toUTCString());
      }
      if (secure && location.protocol === 'https:') {
        https = ';secure';
      }
      document.cookie = name.concat('=', value, expires, '; path=/', https);
    }
  },
  readCookie: function readCookie(name) {
    var value;
    if (typeof document !== 'undefined') {
      var nameEQ = name.concat('=');
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
          value = c.substring(nameEQ.length, c.length);
        }
      }
    }
    return value;
  },
  eraseCookie: function eraseCookie(name) {
    this.createCookie(name, '', -1);
  }
};
export default CookieManager;